import { useDispatch, useSelector } from "react-redux";
import InsufficientPermission from "../../custom/InSufficientPermission";
import Pagination from "@mui/material/Pagination";
import NoDataImg from "../../../assets/img/no-data.gif";
import { v4 as uuidv4 } from "uuid";
import NavBar from "../../structure/NavBar";
import { Box, Switch, Button as MUIButton } from "@mui/material";
import { NavBarTop } from "../../structure/NavBarTop";
import {
  Button,
  Dropdown,
  Form,
  InputGroup,
  Modal,
  Badge,
} from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import { useCallback, useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Utils from "../../constants/Utils";
import { AddMerchantSubscriptionPlan } from "./AddMerchantSubscriptionPlan";
import {
  updateTopHeader,
  updateLoading,
} from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";

const label = { inputProps: { "aria-label": "Size switch demo" } };

export const MerchantSubscriptionPlansList = () => {
  const { formatDate } = Utils();
  const [callAPi, setCallAPi] = useState("");
  const dispatch = useDispatch();
  const LOADING_ENABLE = useSelector((state) => state?.loading);
  const [statusDropdownText, setStatusDropdownText] = useState("Select Status");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });
  const [sort_type, setSortType] = useState("createdAt");
  const [sort_order, setSortOrder] = useState(false);
  const [datalist, setDatalist] = useState([]);
  const [page, setPage] = useState(1);
  const userData = useSelector((state) => state?.userData);
  const [searchText, setSearchText] = useState("");
  const userPermissions = useSelector((state) => state?.permission);

  // Add/Edit Modal states
  const [showAddModal, setShowAddModal] = useState(false);
  const [subscriptionPlanFormData, setSubscriptionPlanFormData] = useState({
    id: "",
    name: "",
    amount: 0,
    merchantSubscriptionCategoryId: "",
    type: "DAILY",
    viewerNetworkMapping: [],
    viewerSubscription: false,
    partnerBenefits: [],
    othersBenefits: [],
  });

  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  // Permission checking - using a generic module ID for merchant subscription plans
  if (userPermissions?.modules.length > 0) {
    currentModulePermission = userPermissions.modules.find((element) => {
      if (element.moduleId === "45") {
        // Update this module ID as per your system
        return element;
      }
    })?.permissions;
    if (currentModulePermission) {
      viewPermission =
        currentModulePermission.find((element) => {
          if (element.name === "VIEW") {
            return element;
          }
        })?.isEnable || false;
      editPermission =
        currentModulePermission.find((element) => {
          if (element.name === "EDIT") {
            return element;
          }
        })?.isEnable || false;
      deletePermissionVal =
        currentModulePermission.find((element) => {
          if (element.name === "DELETE") {
            return element;
          }
        })?.isEnable || false;
      activePermission =
        currentModulePermission.find((element) => {
          if (element.name === "ACTIVE") {
            return element;
          }
        })?.isEnable || false;
    }
  }

  useEffect(() => {
    dispatch(updateTopHeader("Merchant Subscription Plans"));
    if (viewPermission) {
      handleFilterAction();
    }
  }, [viewPermission]);

  useEffect(() => {
    if (callAPi !== "") {
      handleFilterAction();
    }
  }, [callAPi]);

  const handleFilterAction = useCallback(async () => {
    try {
      dispatch(updateLoading(true));
      let postJson = {
        pageNumber: pagerecord?.pageNumber - 1,
        pageSize: pagerecord?.pageSize || 10,
        searchText: searchText?.trim() || "",
        shortingField: sort_type,
        asc: sort_order,
        active:
          statusDropdownText === "Active"
            ? true
            : statusDropdownText === "Inactive"
              ? false
              : null,
        startDate: startDate ? formatDate(startDate?.$d) : null,
        endDate: endDate ? formatDate(endDate?.$d) : null,
      };

      console.log("Merchant Subscription API Request:", postJson);
      console.log("API URL:", urls.merchantSubscriptionPlansList);

      const res = await ApiCaller.post(
        postJson,
        urls.merchantSubscriptionPlansList,
        userData?.access_token
      );
      const response = await res.response.json();

      console.log("Merchant Subscription API Response:", response);

      if (response.status === 200 || response?.status === "200") {
        setDatalist(response?.data?.items || []);
        setPagerecord({
          totalItems: response?.data?.totalItems,
          totalPages: response?.data?.totalPages,
          pageNumber: response?.data?.pageNumber + 1,
          pageSize: response?.data?.pageSize || 10,
        });
      } else {
        showDangerToast(response.message);
      }
    } catch (error) {
      showDangerToast(error.message);
    } finally {
      dispatch(updateLoading(false));
    }
  }, [
    pagerecord?.pageNumber,
    pagerecord?.pageSize,
    sort_type,
    sort_order,
    searchText,
    statusDropdownText,
    startDate,
    endDate,
    userData?.access_token,
    formatDate,
    dispatch,
  ]);

  const resetAllFilters = () => {
    setSearchText("");
    setStartDate(null);
    setEndDate(null);
    setStatusDropdownText("Select Status");
    setPage(1);
    setPagerecord({
      totalItems: 0,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
    });
    setCallAPi(uuidv4());
  };

  const handlePaginationClick = (event, value) => {
    setPage(value);
    setPagerecord({
      ...pagerecord,
      pageNumber: value,
    });
    setCallAPi(uuidv4());
  };

  const changeStatus = async (id) => {
    try {
      dispatch(updateLoading(true));
      let postJson = {
        id: id,
      };
      const res = await ApiCaller.post(
        postJson,
        urls.changeMerchantSubscriptionPlanStatus,
        userData?.access_token
      );
      const response = await res.response.json();

      if (response.status === 200) {
        showToast(response.message);
        setCallAPi(uuidv4());
      } else {
        showDangerToast(response.message);
      }
    } catch (error) {
      showDangerToast(error.message);
    } finally {
      dispatch(updateLoading(false));
    }
  };

  const openAddModal = () => {
    setSubscriptionPlanFormData({
      id: "",
      name: "",
      amount: 0,
      merchantSubscriptionCategoryId: "",
      viewerSubscription: false,
      type: "DAILY",
      partnerBenefits: [],
      othersBenefits: [],
      viewerNetworkMapping: []
    });
    setShowAddModal(true);
  };

  const openEditModal = async (item) => {
    try {
      dispatch(updateLoading(true));
      console.log("Fetching subscription details for ID:", item.id);

      // Construct the URL with query parameter
      const detailsUrl = `${urls.merchantSubscriptionPlanDetails}?id=${item.id}`;
      console.log("Details API URL:", detailsUrl);

      const res = await ApiCaller.get({}, detailsUrl, userData?.access_token);
      const response = await res.response.json();

      console.log("Subscription Details Response:", response);

      if (response.status === 200 || response.status === "200") {
        const data = response.data;

        // Transform partner benefits to include IDs and partner names
        const benefits =
          data.benefits?.map((benefit) => ({
            id: uuidv4(),
            benefitsType: benefit.benefitsType,
            value: benefit.value,
          })) || [];

        // Transform others benefits to include IDs
        const gifts =
          data.gifts?.map((gift) => ({
            id: uuidv4(),
            thresholdValue: gift.thresholdValue,
            instantGift: gift.instantGift,
            accumulatedGift: gift.accumulatedGift,
            type: gift.type,
          })) || [];

        setSubscriptionPlanFormData({
          id: data.id,
          name: data.name,
          amount: data.amount,
          merchantSubscriptionCategoryId: data.merchantSubscriptionCategoryId,
          type: data.type,
          viewerSubscription: data.viewerSubscription,
          viewerNetworkMapping: data.viewerNetworkMapping || [],
          benefits: benefits,
          gifts: gifts,
        });

        setShowAddModal(true);
      } else {
        showDangerToast(
          response.message || "Failed to fetch subscription details"
        );
      }
    } catch (error) {
      console.error("Error fetching subscription details:", error);
      showDangerToast("Failed to load subscription details");
    } finally {
      dispatch(updateLoading(false));
    }
  };

  if (!viewPermission) {
    return <InsufficientPermission />;
  }

  return (
    <>
      <NavBar />
      <div className="main-content">
        <NavBarTop />
        <div className="header">
          <div className="logo">
            <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8"></div>
          </div>
        </div>
        <div className="container-fluid mt--7">
          <div className="row">
            <div className="col text-left">
              <div className="card shadow">
                <div className="card-header border-0">
                  <div className="row align-items-center text-left">
                    <div className="col">
                      <h3 className="mb-0">Merchant Subscription Plans</h3>
                    </div>
                    <div className="col text-right">
                      {editPermission && (
                        <a
                          onClick={openAddModal}
                          className="btn btn-sm btn-primary text-white"
                        >
                          <AddIcon />
                          Add New
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-header border-0">
                  <div className="row align-items-center text-left">
                    <div className="col-md-3">
                      <InputGroup
                        className="mb-2"
                        style={{ borderRadius: "10px" }}
                      >
                        <Form.Control
                          placeholder="Search by Plan Name"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          aria-label="Search by Plan Name"
                        />
                      </InputGroup>
                    </div>
                    <div className="col-md-2 mb-2">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="outline-primary"
                          className="w-100"
                          style={{ borderRadius: "10px" }}
                        >
                          {statusDropdownText}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              setStatusDropdownText("Select Status")
                            }
                          >
                            All
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setStatusDropdownText("Active")}
                          >
                            Active
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setStatusDropdownText("Inactive")}
                          >
                            Inactive
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="col-md-4 mb-3">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker", "DatePicker"]}
                        >
                          <DatePicker
                            disableFuture
                            className="custom-date"
                            label="From Date"
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            maxDate={endDate}
                          />
                          <DatePicker
                            disableFuture
                            label="To Date"
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            minDate={startDate}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div className="col-md-3 mb-2">
                      <MUIButton
                        variant="contained"
                        className="custom-filter-btn"
                        onClick={() => setCallAPi(uuidv4())}
                      >
                        Filter
                      </MUIButton>
                      <MUIButton
                        variant="contained"
                        className="ml-2 custom-filter-btn"
                        onClick={resetAllFilters}
                      >
                        Reset
                      </MUIButton>
                    </div>
                  </div>
                </div>
                <div
                  className="table-responsive"
                  style={{ minHeight: "400px" }}
                >
                  {datalist?.length ? (
                    <>
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col" style={{ minWidth: "150px" }}>
                              Plan Name
                            </th>
                            <th scope="col" style={{ minWidth: "100px" }}>
                              Amount
                            </th>
                            <th scope="col" style={{ minWidth: "100px" }}>
                              Type
                            </th>
                            <th scope="col" style={{ minWidth: "120px" }}>
                              Category
                            </th>
                            <th scope="col" style={{ minWidth: "100px" }}>
                              Status
                            </th>
                            <th scope="col" style={{ minWidth: "120px" }}>
                              Created Date
                            </th>
                            <th scope="col" style={{ minWidth: "100px" }}>
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {datalist?.map((item, index) => (
                            <tr key={index}>
                              <th scope="row">
                                <div className="media align-items-center">
                                  <div className="media-body">
                                    <span className="mb-0 text-sm">
                                      {item.name}
                                    </span>
                                  </div>
                                </div>
                              </th>
                              <td>GHS{item.amount}</td>
                              <td>
                                <Badge
                                  bg={
                                    item.type === "DAILY"
                                      ? "success"
                                      : item.type === "WEEKLY"
                                        ? "info"
                                        : item.type === "MONTHLY"
                                          ? "warning"
                                          : "primary"
                                  }
                                >
                                  {item.type}
                                </Badge>
                              </td>
                              <td>{item.viewer ? 'Viewer' : 'Merchant'}</td>
                              <td>
                                {activePermission ? (
                                  <Switch
                                    {...label}
                                    size="small"
                                    checked={item.active}
                                    onChange={() => changeStatus(item._uuid)}
                                  />
                                ) : (
                                  <Badge
                                    bg={item.active ? "success" : "danger"}
                                  >
                                    {item.active ? "Active" : "Inactive"}
                                  </Badge>
                                )}
                              </td>
                              <td>{formatDate(item.createdAt)}</td>
                              <td>
                                {editPermission && (
                                  <Button
                                    className="btn btn-primary btn-sm me-1"
                                    onClick={() => {
                                      console.log(
                                        "Edit button clicked for item:",
                                        item
                                      );
                                      openEditModal(item);
                                    }}
                                  >
                                    Edit
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <>
                      <div className="text-center">
                        <img width={"25%"} src={NoDataImg} alt="No data" />
                        <br />
                        <label style={{ fontWeight: "bold" }}>
                          {LOADING_ENABLE ? (
                            <>Loading Data.....</>
                          ) : (
                            <>No Subscription Plans Found</>
                          )}
                        </label>
                      </div>
                    </>
                  )}
                </div>

                {datalist && datalist.length > 0 ? (
                  <div className="card-footer py-4">
                    <Box
                      display="flex"
                      justifyContent="right"
                      alignItems="center"
                    >
                      <span>Total Record: {pagerecord?.totalItems}</span>
                      <Pagination
                        className="custom-pagination-class"
                        count={pagerecord?.totalPages}
                        page={page}
                        onChange={handlePaginationClick}
                        color="secondary"
                      />
                    </Box>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <NavBar />

      {/* Add/Edit Modal */}
      {showAddModal && (
        <AddMerchantSubscriptionPlan
          showModal={showAddModal}
          setShowModal={setShowAddModal}
          formData={subscriptionPlanFormData}
          setFormData={setSubscriptionPlanFormData}
          setCallAPi={setCallAPi}
        />
      )}
    </>
  );
};
